import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../style/Header.css';
// import logo from '../img/quanto_light-1.png'; // Placeholder path for logo image
import logo from '../img/quanto_light.png'; // Placeholder path for logo image
import darkmodetoggle from '../img/dark-mode-toggle.png';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp'; // Import WhatsApp icon
import { ArrowDropDownRounded } from '@mui/icons-material';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const [productsOpen, setProductsOpen] = useState(false);

  const whatsappNumber = "+917904159558"; // Replace with your WhatsApp number

  // check if mobile
  const isMobile = window.innerWidth < 768;

  return (
    <div style={{ all: 'unset' }}>
      {/* <div className="header-top">
        <div className="header-top-left">
        </div>
        <div className="header-top-right">
          <span className="header-company">Company</span>
          <span className="header-login">Login</span>
        </div>
      </div> */}
      {/* <img src={darkmodetoggle} alt="Light/Dark Mode Toggle" className="toggle" /> */}
      <header className="header">
        <div className="header__logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="header-toggle" onClick={toggleMenu}>
          {!menuOpen ? <MenuIcon /> : <CloseIcon />}
        </div>
        <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
          <Link to="/why-quanto" className="header__nav-item">Why Quanto?</Link>
          <Link to="/features" className="header__nav-item">Features</Link>
          <Link to="/unlock-profit" className="header__nav-item">Unlock Profit</Link>
          <div className="header__nav-item dropdown" onClick={() => setProductsOpen(!productsOpen)}>
            Products
            <ArrowDropDownRounded style={{ fontSize: 40 }} className='dropdown-icon' />
            <div className="dropdown-menu" style={isMobile ? { display: productsOpen ? 'block' : 'none' } : {}}>
              <Link to="/products/quanto-retail-erp" className="dropdown-item">Quanto Retail ERP</Link>
              <Link to="/products/saas" className="dropdown-item">Quanto Saas</Link>
              <Link to="/products/quanto-mobile-app" className="dropdown-item">Quanto Mobile App</Link>
              <Link to="/products/quantofyP" className="dropdown-item">Quantofyy - Your E-Com Platform</Link>
              <Link to="/products/quanto-b2b" className="dropdown-item">Quanto B2B</Link>
              <Link to="/products/mfg" className="dropdown-item">Quanto Manufacturing</Link>
              <Link to="/products/mart" className="dropdown-item">Quanto Mart</Link>
              <Link to="/products/collect" className="dropdown-item">Quanto Collection Management</Link>
              <Link to="/products/bridge" className="dropdown-item">Quanto Bridge Platform - Coming Soon!</Link>
            </div>
          </div>
          <Link to="/about" className="header__nav-item">About Us</Link>
          <Link to="/clients-trust" className="header__nav-item">Clients Trust</Link>
          <Link to="/pricing" className="header__nav-item">Pricing</Link>
          <Link to="/get-demo" className="header__nav-item">Get Demo</Link>
          <Link to="http://blog.quantoretail.com/" className="header__nav-item">Blog</Link>
        </nav>
      </header>
    </div>
  );
};

export default Header;
